// Static option lists + enums for the Crude Registration Create wizard.
// See .claude/formview-reference/crude-registration/{rule,api}-crude-registration.md.

// Origin: contract (api-crude-registration.md) fixes this to Domestic | Import.
// (The rule text says "value dari DB", but no lookup endpoint is defined — using
// the contract's static enum until a lookup is confirmed. Kept here so a future
// DB-backed list is a one-line swap.)
export const ORIGIN_OPTIONS = [
  { value: 'Domestic', label: 'Domestic' },
  { value: 'Import', label: 'Import' },
];

// Tab 3 — Technical Evaluation Status. Sent as boolean `technicalStatus`
// (Approved = true / Not Approved = false), per the CreateCrudeRequest DTO.
export const TECHNICAL_STATUS_OPTIONS = [
  { value: 'true', label: 'Approved' },
  { value: 'false', label: 'Not Approved' },
];

// Tab 3 — Plant Test Status. Contract serialises `implementationStatus` as a
// number; UI offers 3 options. Numeric mapping is a BE assumption to confirm —
// centralised here so it's a single edit if the enum differs.
export const PLANT_TEST_STATUS_OPTIONS = [
  { value: 1, label: 'Proven' },
  { value: 2, label: 'Not Proven' },
  { value: 3, label: 'Not Yet' },
];

// Tab 1 — Yield section fields. `key` is the payload/property name; the read-only
// Total Yield is the sum of these (must equal 100 to pass validation).
export const YIELD_FIELDS = [
  { key: 'gas', label: 'Gas', required: true },
  { key: 'lNaphta', label: 'L Naphta (LN)', required: true },
  { key: 'hNaphta', label: 'H Naphta (HN)', required: true },
  { key: 'kerosene', label: 'Kerosene (KR)', required: true },
  { key: 'lGasoil', label: 'L Gasoil (LO)', required: true },
  { key: 'hGasoil', label: 'H Gasoil (HO)', required: true },
  { key: 'residu', label: 'Residu (RS)', required: true },
];

// Tab 1 — Assay Detail fields (right column). `dp` = decimal places hint for the
// step attribute; `required` marks the mandatory asterisk + validation.
export const ASSAY_FIELDS = [
  {
    key: 'assaYear',
    label: 'Assay Year',
    type: 'number',
    step: '1',
    min: 1900,
    required: true,
  },
  { key: 'lab', label: 'Lab', type: 'text', required: true },
  { key: 'api', label: 'API', type: 'number', step: '0.001', required: true },
  {
    key: 'sulfur',
    label: 'Sulfur (%-WT)',
    type: 'number',
    step: '0.001',
    required: true,
  },
  {
    key: 'pourPoint',
    label: 'Pour Point (°C)',
    type: 'number',
    step: '0.001',
    required: true,
  },
  { key: 'tan', label: 'TAN (mgKOH/g)', type: 'number', required: false },
  {
    key: 'asphaltene',
    label: 'Asphaltene (%wt)',
    type: 'number',
    required: false,
  },
  { key: 'sg', label: 'SG (60/60)', type: 'number', required: false },
  { key: 'salt', label: 'Salt (PTB)', type: 'number', required: false },
  { key: 'sw', label: 'S&W (%-VOL)', type: 'number', required: false },
  { key: 'mercury', label: 'Mercury (PPB)', type: 'number', required: false },
];

// Master-list source endpoints (both on crudeApi — 06.WebApi.Crude host).
export const EVALUATION_DOCUMENT_LIST =
  '/v1/EvaluationDocument/GetListEvaluationDocument';
export const CDU_LIST = '/v1/CDU/GetListCDU';

// EvaluationDocument `evaluationType` filter (api-crude-registration.md §D4):
// Tab 2 (checklist) uses Evaluation (the BE default); Tab 3 (5 fixed seed
// attachments: Crude Assay / CRU / BA Approved-Non / BA Proven-Non / Other Doc)
// MUST send Implementation explicitly or it silently falls back to Evaluation.
export const EVALUATION_TYPE = {
  EVALUATION: 'Evaluation',
  IMPLEMENTATION: 'Implementation',
};

// Accepted upload formats for the Draft document flow (§D4: .pdf/.cru).
export const CRUDE_DOC_ACCEPT = '.pdf,.cru';

// Fetch a large page to load the full lookup in one call (lists are small).
export const LOOKUP_PAGE_SIZE = 100;
